
export default {
  profileSelector: {
    activeProfile: 'Activ'
  }
}
